import React, { useEffect } from "react";
import "./main-banner.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import FAQ from "./faq";
import Header from "../../components/header";

const HomeBanner = () => {
  const handleScrollToNext = () => {
    const nextSection = document.getElementById("next-section");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="faq-banner">
        <div className="faq-h-banner-container">
          {/* Left Section */}
          <div
            className="faq-h-design faq-slider-left-time"
            style={{ animationDelay: "0.4s" }}
          >
            <div className="faq-h-left"></div>
          </div>

          {/* Middle Section */}
          <div
            className="faq-h-design faq-slider-left-time"
            style={{ animationDelay: "0.4s" }}
          >
            <div className="faq-h-design-N">
              <div className="faq-h-left-N"></div>
              <div style={{ height: "350px" }} />
              <div className="faq-h-right-N"></div>
            </div>
          </div>

          {/* Right Section */}
          <div
            className="faq-h-design faq-slider-left-time"
            style={{ animationDelay: "0.4s" }}
          >
            <div className="h-right"></div>
          </div>
        </div>

        {/* White Box */}
        <div className="faq-white-box">
          <div className="faq-white-box-container">
            <h1>
              FAQs <span className="faq-white-box-container-h1"></span>
            </h1>

            {/* Button to scroll to the next section */}
            <button onClick={handleScrollToNext} className="faq-scroll-button">
              <FontAwesomeIcon
                icon={faArrowDown}
                style={{ fontSize: "16px" }}
              />
            </button>
          </div>
        </div>
      </div>
      <FAQ />
    </>
  );
};

export default HomeBanner;
